/**
 * Robust, cross-browser CSV file download utility.
 * Prevents Chrome / macOS from saving blob UUIDs (e.g. 7176f3d3-...) without extensions.
 */
export function downloadCsvFile(filename: string, csvContent: string, serverFallbackUrl?: string) {
  try {
    // 1. Ensure clean .csv extension
    const cleanFilename = filename.toLowerCase().endsWith(".csv") ? filename : `${filename}.csv`;

    // 2. Ensure UTF-8 BOM is present for Excel / Numbers compatibility
    const contentWithBom = csvContent.charCodeAt(0) === 0xfeff ? csvContent : "\uFEFF" + csvContent;

    // 3. For typical export/template sizes (< 1.5 MB), data URI is 100% immune to Chrome's blob UUID bug
    if (contentWithBom.length < 1500000) {
      const encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(contentWithBom);
      const link = document.createElement("a");
      link.href = encodedUri;
      link.setAttribute("download", cleanFilename);
      link.download = cleanFilename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        if (link.parentNode) {
          document.body.removeChild(link);
        }
      }, 1000);
      return;
    }

    // 4. For large exports (> 1.5 MB), use a strictly validated Blob (no trailing semicolon in MIME)
    const blob = new Blob([contentWithBom], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", cleanFilename);
    link.download = cleanFilename;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      if (link.parentNode) {
        document.body.removeChild(link);
      }
      URL.revokeObjectURL(url);
    }, 60000);
  } catch (err) {
    console.error("[downloadCsvFile Error]:", err);
    if (serverFallbackUrl) {
      window.location.assign(serverFallbackUrl);
    }
  }
}
